// =============================================================
//  All homepage content lives here.
//  Replace every [BRACKETED] value with real data.
//  Images: set `image` to a URL (e.g. '/img/alfama.jpg');
//  while it is null a labelled placeholder is shown instead.
// =============================================================

export const brand = {
  name: 'Guiders',
  whatsapp: 'https://wa.me/351920043375', // [YOUR WHATSAPP NUMBER]
  email: 'support@guiders.pt',               // [CHECK]
  dmcEmail: 'support@guiders.pt',              // [CHECK]
  phone: '+351 920 043 375',
  whatsappAdmin: 'https://wa.me/351920494883', // [YOUR WHATSAPP NUMBER]
  phoneAdmin: '+351 920 494 883',               // [YOUR PHONE]
  address: '[Address], Lisbon',
  rnaat: '[RNAAT nº]',
  logoFullWhite: require('../assets/logo_full_white.png'),
  // rnavt: '[RNAVT nº]',
};

// Header menu. Labels are translated (src/i18n/locales, `nav.<key>`).
// `path` pages exist in every language, so links stay in the visitor's
// language; `href` pages are English only.
export const navLinks = [
  { key: 'visitorPass', label: 'Lisbon Visitor Pass', path: '/lisbon-visitor-pass' },
  { key: 'tukTuk', label: 'Tuk Tuk Tours', path: '/', hash: '#tuk-tuk' },
  { key: 'guides', label: 'Private Guides', path: '/', hash: '#guides' },
  { key: 'portugalTours', label: 'Portugal Tours', path: '/', hash: '#city-tours' },
  { key: 'agencies', label: 'Agencies & Groups', path: '/portugal-dmc' },
];

export const pass = {
  price: '29€',
  rating: '4.9',
  reviews: '[XX]',
  buyUrl: 'https://guiders.pt/lisbon-visitor-pass#pricing',      // [LINK TO PASS CHECKOUT]
  routeUrl: 'lisbon-visitor-pass',    // [LINK TO ROUTE & STOPS PAGE]
  cancellation: 'Cancel for free up to 24 hours before',
  image: null,
  imageLabel: 'video of guests hopping off your tuk tuk at a miradouro, pass QR visible on a phone',
};

export const comparison = {
  columns: ['Lisbon Visitor Pass', 'Hop-on hop-off bus', 'Private tuk tuk tour'],
  rows: [
    { label: 'Gets up to the hilltop viewpoints', values: ['Yes', 'Main avenues only', 'Yes'] },
    { label: 'Local guide on board', values: ['Yes', 'No', 'Yes'] },
    { label: 'Hop off, explore, hop back on', values: ['Yes, all day', 'Yes', 'No, fixed 1–4h'] },
    { label: 'Need to book a time slot', values: ['No, just show up', 'No', 'Yes'] },
    { label: 'Wait for the next ride', values: ['Usually under 10 min', '30 minutes', 'No wait'] },
    { label: 'Group size', values: ['Small, max 6 per tuk tuk', 'Large double-decker', 'Your group only'] },
  ],
  bestFor: {
    label: 'Best for',
    values: [
      'Exploring at your own pace',
      'Long distances on a budget',
      'Special occasions, full attention',
    ],
  },
};

export const tours = [
  {
    name: 'Lisbon: 1-Hour Private Tuk-Tuk Tour of Alfama & Old Town',
    desc: 'Narrow lanes, fado streets and the best viewpoints over the river.',
    meta: '1h · Private · Hotel pick-up',
    price: '85€',
    badge: 'Most booked',
    url: 'https://guiders.pt/details/t78nJPOAbsW4DuwDnZa8/lisbon-1-hour-private-tuk-tuk-tour-of-alfama-&-old-town',
    image: 'https://firebasestorage.googleapis.com/v0/b/tours-26f02.appspot.com/o/IMG_2523%20(1).jpg?alt=media&token=935c84e0-e48f-460f-b4fc-e2c0f7b01984',
    imageLabel: 'Photo: tuk tuk in an Alfama lane',
  },
  {
    name: 'Lisbon: 2-Hour Private Tuk-Tuk Tour of Alfama & Chiado',
    desc: 'Old town, Baixa.',
    meta: '2h · Private · Hotel pick-up',
    price: '145€',
    badge: 'Best value',
    url: 'https://guiders.pt/details/63mFURw6KKq6ZFTmGtMQ/lisbon-2-hour-private-tuk-tuk-tour-of-alfama-&-chiado',
    image: require("../assets/psol.jpg"),
    imageLabel: 'Photo: guide pointing out the view at a miradouro',
  },
  {
    name: 'Lisbon: 3-Hour Private Tuk-Tuk Tour of Old Town & Belém',
    desc: 'Jerónimos, Belém Tower and the monument to the navigators.',
    meta: '3h · Private · Hotel pick-up',
    price: '200€',
    badge: 'Private',
    url: 'https://guiders.pt/details/FyBrCr0owDZFSWu7mag7/lisbon-3-hour-private-tuk-tuk-tour-of-old-town-&-belém',
    image: require("../assets/jeronimos.jpg"),
    imageLabel: 'Photo: tuk tuk at Belém Tower',
  },
  {
    name: 'Lisbon: 3-Hour Private Tuk-Tuk Food & Wine Tasting Tour',
    desc: 'Wine and cheese, presunto, a bifana, codfish cakes and pastel de nata between old-town rides.',
    meta: '3h · Private · 4 tasting stops',
    price: '340€',
    badge: 'Food & wine',
    url: 'https://guiders.pt/details/2YSKuittviXRcAIvgSB0/lisbon-3-hour-private-tuk-tuk-food-&-wine-tasting-tour',
    image: require("../assets/pfood.jpg"),
    imageLabel: 'Photo: wine and petiscos on the food tour',
  },
];

// Each guide has their own cities and languages.
export const guides = [
  {
    name: 'Cintia Ferreira',
    since: 'Licensed guide since [year]',
    bio: '[One or two lines: specialty and personality.]',
    cities: ['Fátima', 'Évora', 'Nazaré', 'Cascais', 'Braga', 'Óbidos', 'Coimbra', 'Porto', 'Sintra'],
    languages: ['English', 'Portuguese'],
    image: require("../assets/guides/cintia.jpeg"),
  },
  {
    name: 'João Dias',
    since: 'Licensed guide since [year]',
    bio: '[One or two lines: specialty and personality.]',
    cities: ['Porto', 'Coimbra', 'Aveiro', 'Vale do Douro', 'Viana do Castelo', 'Barcelos', 'Guimarães', 'Évora', 'Braga', 'Óbidos', 'Fátima', 'Nazaré', 'Algarve'],
    languages: ['English', 'Portuguese', 'Spanish'],
    image: require("../assets/guides/joao_dias.jpg"),
  },
  {
    name: 'Mafalda Sousa',
    since: 'Licensed guide since [year]',
    bio: '[One or two lines: specialty and personality.]',
    cities: ['Lisbon', 'Sintra', 'Fátima', 'Évora', 'Nazaré', 'Cascais', 'Braga', 'Óbidos', 'Coimbra', 'Porto'],
    languages: ['English', 'Portuguese'],
    image: require("../assets/guides/mafalda_sousa.jpg"),
  },
  {
    name: 'Luis Pena',
    since: 'Licensed guide since 2019',
    bio: '[One or two lines: specialty, e.g. wine and Alentejo countryside.]',
    cities: ['Lisbon', 'Fátima', 'Évora', 'Nazaré', 'Cascais', 'Óbidos', 'Coimbra', 'Sintra'],
    languages: ['English', 'Portuguese', 'Spanish'],
    image: require("../assets/guides/luis_pena.jpg"),
  },
  {
    name: 'Lara Loureiro',
    since: 'Licensed guide since [year]',
    bio: '[One or two lines: specialty, e.g. Porto, Douro and port wine.]',
    cities: ['Lisbon', 'Fátima', 'Évora', 'Nazaré', 'Cascais', 'Óbidos', 'Coimbra', 'Porto', 'Sintra', 'Arrábida', 'Aveiro'],
    languages: ['English', 'Portuguese', 'Spanish'],
    image: require("../assets/guides/lara_loureiro.jpeg"),
  },
  {
    name: 'Guilherme Santos',
    since: 'Licensed guide since [year]',
    bio: '[One or two lines: specialty, e.g. family-friendly tours and the Algarve coast.]',
    cities: ['Lisbon', 'Fátima', 'Évora', 'Nazaré', 'Algarve', 'Braga', 'Cascais', 'Óbidos', 'Porto', 'Coimbra', 'Sintra', 'Faro'],
    languages: ['English', 'Spanish', 'French', 'Portuguese'],
    image: require("../assets/guides/guilherme_s.jpeg"),
  },
  {
    name: 'Nelia Alves',
    since: 'Licensed guide since [year]',
    bio: '[One or two lines: specialty, e.g. family-friendly tours and the Algarve coast.]',
    cities: ['Madeira island'],
    languages: ['English', 'French', 'Portuguese'],
    image: require("../assets/guides/nelia.png"),
  },
  {
    name: 'Catarina Lopez',
    since: 'Licensed guide since [year]',
    bio: '[One or two lines: specialty, e.g. Porto, Douro and port wine.]',
    cities: ['Lisbon', 'Évora', 'Fátima', 'Nazaré', 'Cascais', 'Óbidos', 'Coimbra', 'Sintra'],
    languages: ['English', 'Portuguese', 'Spanish'],
    image: require("../assets/guides/kata.jpg"),
  },
  {
    name: 'Margarida Pereira',
    since: 'Licensed guide since [year]',
    bio: '[One or two lines: specialty, e.g. Porto, Douro and port wine.]',
    cities: ['Lisbon', 'Fátima', 'Évora', 'Nazaré', 'Cascais', 'Óbidos', 'Coimbra', 'Porto', 'Sintra', 'Algarve', 'Madeira island'],
    languages: ['English', 'Portuguese', 'German'],
    image: require("../assets/guides/margarida.jpg"),
  },
  {
    name: 'Manuel Morais',
    since: 'Licensed guide since [year]',
    bio: '[One or two lines: specialty, e.g. Porto, Douro and port wine.]',
    cities: ['Porto', 'Guimarães', 'Douro Valley', 'Braga'],
    languages: ['English', 'Portuguese'],
    image: require("../assets/guides/manuel.jpg"),
  },
  {
    name: 'Joana Gonçalves ',
    since: 'Licensed guide since [year]',
    bio: '[One or two lines: specialty, e.g. family-friendly tours and the Algarve coast.]',
    cities: ['Porto', 'Braga', 'Lisbon', 'Coimbra', 'Viseu'],
    languages: ['English', 'German', 'Portuguese'],
    image: require("../assets/guides/joana.jpg"),
  },
  {
    name: 'Ana Lopes',
    since: 'Licensed guide since [year]',
    bio: '[One or two lines: specialty, e.g. family-friendly tours and the Algarve coast.]',
    cities: ['Lisbon', 'Fátima', 'Sintra', 'Nazaré', 'Óbidos', 'Cascais', 'Évora'],
    languages: ['Portuguese', 'English', 'Spanish', 'Italian', 'French', 'German'],
    image: require("../assets/guides/ana_lopes.jpeg"),
  },
  {
    name: 'Pedro Grangeio',
    since: 'Licensed guide since [year]',
    bio: '[One or two lines: specialty, e.g. family-friendly tours and the Algarve coast.]',
    cities: ['Lisbon', 'Fátima', 'Nazaré', 'Cascais', 'Óbidos', 'Sintra', 'Porto'],
    languages: ['Portuguese', 'English', 'French'],
    image: require("../assets/guides/pedro.png"),
  },

  {
    name: 'Daniel Afonso',
    since: 'Licensed guide since [year]',
    bio: '[One or two lines: specialty, e.g. family-friendly tours and the Algarve coast.]',
    cities: ['Fátima', 'Nazaré', 'Braga', 'Coimbra', 'Porto', 'Guimarães', 'Viana do Castelo', 'Amarante', 'Lamego', 'Aveiro', 'Viseu'],
    languages: ['Portuguese', 'Spanish', 'French', 'Italian', 'English'],
    image: require("../assets/guides/daniel.jpg"),
  },
  {
    name: 'Maria do Carmo Petersen',
    since: 'Licensed guide since [year]',
    bio: '[One or two lines: specialty, e.g. family-friendly tours and the Algarve coast.]',
    cities: ['Fátima', 'Braga', 'Coimbra', 'Porto', 'Douro Valley', 'Guimarães', 'Aveiro', 'Viana do Castelo'],
    languages: ['Portuguese', 'Spanish', 'English'],
    image: require("../assets/guides/carmo.jpg"),
  },
];

export const trips = [
  { name: 'Sintra & Cascais', meta: 'Full day · Any size group', price: 'from 460€', url: 'https://guiders.pt/details/D1YH6p0pVThgornEsYhe/from-lisbon-private-sintra,-pena-palace-&-cabo-da-roca-tour', image: 'https://firebasestorage.googleapis.com/v0/b/tours-26f02.appspot.com/o/sintra-pena-060-65467351c0fae-65467e5a10b62.webp?alt=media&token=61421dc5-d2cb-4141-b254-80ceb4e339e0', imageLabel: 'Photo: Pena Palace' },
  { name: 'Fátima, Óbidos & Nazaré', meta: 'Full day · Any size group', price: 'from 460€', url: 'https://guiders.pt/details/GqLu48OlVVI3sH6BwGZm/from-lisbon-private-fátima,-nazaré-&-óbidos-day-trip', image: 'https://firebasestorage.googleapis.com/v0/b/tours-26f02.appspot.com/o/y79ixtzx8n%2Fimage%20310.png?alt=media&token=fa22d1a2-8108-4ce4-bd29-68a15ca37bce', imageLabel: 'Photo: Óbidos walls' },
  { name: 'Tomar', meta: 'Full day · Any size group', price: 'from 460€', url: 'https://guiders.pt/details/JDO7uP17SaMlx8Y21gl8/from-lisbon-private-tomar-&-templar-convent-of-christ-tour', image: 'https://firebasestorage.googleapis.com/v0/b/tours-26f02.appspot.com/o/1024px-Igreja_Santa_Maria_do_Olival_em_Tomar_6.jpg?alt=media&token=f955e3eb-4a34-4c17-8a66-6c737f58e752', imageLabel: 'Photo: Tomar cathedral' },
  { name: 'Évora', meta: 'Full day · Any size group', price: 'from 460€', url: 'https://guiders.pt/details/SfuJZtcgdYvaU2MgTbwj/from-lisbon-private-%C3%A9vora-day-trip-with-chapel-of-bones', image: 'https://firebasestorage.googleapis.com/v0/b/tours-26f02.appspot.com/o/ebps84dgefq%2Fportuguese-gravity--dGw47Rwhdk-unsplash.jpg?alt=media&token=fdde57f2-b833-4948-8d85-d9c4c5fcae77', imageLabel: 'Photo: Évora temple' },
];

export const dmc = {
  proposalUrl: 'https://guiders.pt/portugal-dmc#proposal',   // [LINK TO PROPOSAL FORM]
  programmeUrl: '#',  // [LINK TO AGENT PROGRAMME PDF]
  replyTime: '24h',
  services: [
    { title: 'Groups', text: 'Multi-day circuits, coaches, guides, hotels and meals across Portugal.' },
    { title: 'FIT', text: 'Tailor-made private itineraries for your individual clients.' },
    { title: 'Incentives & events', text: 'Team experiences, gala dinners, venues and activities.' },
    { title: 'Ground services', text: 'Transfers, guides, tickets and on-site assistance.' },
  ],
};

export const whyUs = [
  { title: 'Local, not a reseller', text: 'Our own guides, vehicles and suppliers. One team from booking to drop-off.' },
  { title: 'Fully licensed', text: '[RNAAT nº] · [RNAVT nº] · Lisbon parking permits [nº]' },
  { title: 'All of Portugal', text: 'Lisbon, Sintra, Porto, Douro, Alentejo, Algarve, with the same standards.' },
  { title: 'Real reviews', text: '[Embed live Google / Tripadvisor / GetYourGuide reviews]' },
];

// FAQ, grouped by service. Answers use facts already stated elsewhere on
// the site (visitor pass page, tour pages, DMC page, footer). [BRACKETED]
// answers still need your policy.
export const faqs = [
  {
    category: 'Lisbon Visitor Pass',
    items: [
      { q: 'How does the Lisbon Visitor Pass work?', a: 'Choose a 4-hour or full-day pass. At any of our 8 pickup stops, message the number on your pass and a tuk tuk with a local driver-guide comes to you. Ride to the next stop, hop off to explore, and call again whenever you are ready.' },
      { q: 'When does my pass start?', a: 'Your hours start from your first ride, not from the moment you buy. An unused pass is valid for 12 months after purchase.' },
      { q: 'How long will I wait for a tuk tuk?', a: 'The average wait is under 10 minutes. Tuk tuks run between 11:00 and 17:30.' },
      { q: 'Which pass length should I choose?', a: 'The 4-hour pass (29€) is a good overview of the main neighbourhoods. The full-day pass (33€) is our most popular, with time for lunch, longer stops and every viewpoint at an easy pace.' },
      { q: 'Do I share the tuk tuk with other people?', a: 'Rides can be shared, with a maximum of 6 people per tuk tuk. If you want the tuk tuk to yourselves, book one of our private tuk tuk tours instead.' },
      { q: 'Where can I buy the pass?', a: 'Online on this site, or from one of our verified resellers in Lisbon. Your pass arrives by email, so there is nothing to print.' },
    ],
  },
  {
    category: 'Tours & day trips',
    items: [
      { q: 'What is the difference between a private tour and the pass?', a: 'A private tour is just for your group, with a set duration (1 to 3 hours), hotel pick-up and a guide who follows your interests the whole time. The pass is more flexible: you ride between stops and explore on your own in between.' },
      { q: 'Do private tours include hotel pick-up?', a: 'Yes. Private tuk tuk tours include pick-up from your hotel or accommodation in central Lisbon.' },
      { q: 'Do you run day trips outside Lisbon?', a: 'Yes. We run full-day private trips from Lisbon to Sintra and Cascais, Fátima, Óbidos and Nazaré, Tomar and more, for groups of any size, from 460€ per group.' },
    ],
  },
  {
    category: 'Agencies & groups',
    items: [
      { q: 'Do you work with travel agencies and tour operators?', a: 'Yes. As a Portugal DMC we handle groups, FIT travellers, incentives and events, and ground services such as transfers, guides, coaches from 16 to 55 seats and on-site assistance, at net rates for the trade.' },
      { q: 'How do I request a proposal?', a: 'Send us your brief through the proposal form on our DMC page, with dates, group size, destinations and services. We reply within 24 hours.' },
    ],
  },
  {
    category: 'Booking & payment',
    items: [
      { q: 'How do I know my booking is confirmed?', a: 'After payment you receive an email with your booking details. If it does not arrive, email support@guiders.pt or message us on WhatsApp at +351 920 043 375.' },
      { q: 'Can I cancel?', a: 'The Visitor Pass can be cancelled for free up to 24 hours before you plan to use it, and private tours up to 48 hours before the start. Refunds go back to the payment method you used. If we ever have to cancel, you always get a full refund.' },
      { q: 'Which payment methods do you accept?', a: 'All major cards (Visa, Mastercard, American Express and more), Apple Pay, Google Pay, Klarna, iDEAL, Bancontact, Alipay and others at checkout.' },
      { q: 'I am running late. What should I do?', a: 'Let us know as soon as possible by WhatsApp at +351 920 043 375 or by email at support@guiders.pt, and we will do our best to adjust.' },
    ],
  },
];
